import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {CompanyDetailsSearchModel} from "../company-details-search.model";
import {CompanyDetailsSearchPageComponent} from "../company-details-search-page/company-details-search-page.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {CompanyDetailsEditPageComponent} from "../company-details-edit-page/company-details-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CompanyDetailsSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-company-details-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(CompanyDetailsSearchModel)
    ]
})
export class CompanyDetailsSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<CompanyDetailsSearchModel> {
    constructor(model: CompanyDetailsSearchModel, injector: Injector) {
        super(model, injector, "companyDetailsId", "companyName");

        this.extendedSearchComponent = CompanyDetailsSearchPageComponent;
        this.extendedEditComponent = CompanyDetailsEditPageComponent;
    }
}
